import { IAccreditationsConfig } from '@orcha/types/package';
import { IMicrositeConfiguration } from 'src/interfaces/microsite';
import { SearchService } from 'src/services';
import { Services } from 'src/services/types';
import { myContainer } from 'src/services/inversify.config';
import { AppCardListWidgetConfiguration } from './AppCardListWidget.configuration';

const DEFAULT_APP_CARD_LIMIT = 9;

export const appCardListContainerDataFetcher = (
  widgetId: string,
  widgetConfiguration: object,
  site: IMicrositeConfiguration,
  language?: string,
  country?: string,
  accreditationsConfig?: IAccreditationsConfig
) => {
  const searchService = myContainer.get<SearchService>(Services.SearchService);

  const appCardListConfig =
    widgetConfiguration as AppCardListWidgetConfiguration;
  const { appCardLimit, appContainerId } = appCardListConfig;
  const numberOfAppsToGet =
    appCardLimit && appCardLimit < DEFAULT_APP_CARD_LIMIT
      ? appCardLimit
      : DEFAULT_APP_CARD_LIMIT;

  const getResult = async () => {
    const result = appContainerId
      ? await searchService.getSearchResults(
          site.tenantId,
          site.packageId,
          appContainerId,
          {
            pageSize: numberOfAppsToGet,
            language,
            country,
          },
          accreditationsConfig
        )
      : undefined;
    return { widgetId, result };
  };

  return getResult();
};
